export default __webpack_public_path__ + "static/media/bg-step2.0f4aca3b.jpg";